// @ts-strict-ignore
import React from 'react';

import {Calculation, CalculationTypes, MetricEntryMeasurement} from 'common/query-builder/query-entry-section/types';
import {SelectReact} from 'common/components/select';
import {SelectTheme} from 'common/components/select/constants';
import {generateCountCalculationMenuOptions} from 'common/query-builder/query-block/count-menu/util';
import {getSelectedCalculation, getSelectedCalculationLabel} from 'common/query-builder/query-entry-section/util';
import {useTranslation} from 'common/i18n/hooks';
import {MultiAttributionMeasurement} from 'iron/common/query-builder/query-entry-section/row-types/new-metric-entry/common/multi-attribution';
import {ButtonSize} from 'common/components/button/constants';

import type {RowProps} from '../catalog';
import styles from './index.module.styl';

/**
 * Shows controls for a formula's count type: rolling or cumulative options.
 */
export function FormulaMeasurement(props: RowProps) {
  const {t, print} = useTranslation();

  const calculation = getSelectedCalculation(props.entry.measurement || {});

  const handleCalculationSelected = (updatedCalculation: Calculation | null) => {
    const measurement: MetricEntryMeasurement = {};

    if (updatedCalculation?.calculationType === CalculationTypes.Rolling) {
      measurement.rolling = {rollingWindowSize: updatedCalculation.rollingWindowSize};
      measurement.cumulative = false;
    } else if (updatedCalculation?.calculationType === CalculationTypes.Cumulative) {
      measurement.rolling = null;
      measurement.cumulative = true;
    }
    props.updateEntry({
      ...props.entry,
      measurement,
    });
  };

  return (
    <div className={styles.measurement}>
      {props.children}
      <SelectReact
        key='calculation-selector'
        elref='calculationSelector'
        label={
          calculation.calculationType
            ? print(getSelectedCalculationLabel(calculation, props.sectionProps.dateUnit))
            : t(`common.standard`)
        }
        disableSearch
        menuWidth={180}
        trackName={props.sectionProps.trackName}
        theme={SelectTheme.Tertiary}
        disableTooltip
        onChange={(ev: CustomEvent) => handleCalculationSelected(ev.detail.item.value)}
        size={ButtonSize.Small}
        sections={generateCountCalculationMenuOptions({
          selectedPlotStyle: props.sectionProps.plotStyle,
          selectedCalculation: calculation,
          selectedDateUnit: props.sectionProps.dateUnit,
          includeStandardItem: true,
        })}
      />

      {/* Multi Attribution selection */}
      <MultiAttributionMeasurement {...props} />
    </div>
  );
}
